import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import '@/common/flexible.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
const moment = require('moment');
Vue.prototype.$moment = moment
import '@/common/element-variables.scss';
// 提示弹窗
import TipPlugin from '@/components/Tip/Tip.plugin';
Vue.use(TipPlugin);
// 动画
import 'animate.css';
// 兼容样式
import '@/common/arco.css';
// svg
import '@/common/svg.js'
// 路由
import router from '@/router/index.js'
// 状态
import store from '@/store/index.js'
// 混入
import mixins from '@/mixins/index.js'
Vue.mixin(mixins)
// 自定义指令
import '@/common/directive.js'


new Vue({
	router,
	store,
	render: h => h(App),
	beforeCreate() {
		Vue.prototype.$bus = this //安装全局事件总线
	}
}).$mount('#app')